
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredb3c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredb3c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iOiPU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animator = void 0;
var $db1b81f84458a82c$var$Animator = /** @class */ function() {
    function Animator(timelines) {
        this._pausedTime = undefined;
        this._lastTime = Date.now();
        this._startTime = Date.now();
        this._timelines = timelines;
        this._animationFrame = null;
    }
    Object.defineProperty(Animator.prototype, "isRunning", {
        get: function() {
            return Boolean(this._animationFrame);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animator.prototype, "startTime", {
        get: function() {
            return this._startTime;
        },
        set: function(startTime) {
            this._startTime = startTime;
        },
        enumerable: false,
        configurable: true
    });
    Animator.prototype.onTick = function(onTick) {
        this._onTick = onTick;
    };
    Animator.prototype.onStep = function(onStep) {
        this._onStep = onStep;
    };
    Animator.prototype.computeFrameAt = function(time) {
        var _a;
        var elapsedTime = time - this._startTime;
        var deltaTime = (time - this._lastTime) / 1000; // In sec
        this._lastTime = time;
        for(var _i = 0, _b = this._timelines; _i < _b.length; _i++){
            var timeline = _b[_i];
            var timelineTime = elapsedTime % timeline.totalDuration;
            var step = timeline.getCurrentStep(timelineTime);
            if (step) {
                var durationUntilStep = timeline.getDurationUntilStep(step);
                var stepTime = (timelineTime - durationUntilStep) / step.duration;
                /**
                 * Trigger the on start callback on the first frame of a step.
                 */ if (step !== timeline.lastStep || timeline.lastStepTime > stepTime) {
                    if ((_a = timeline.lastStep) === null || _a === void 0 ? void 0 : _a.onEnd) timeline.lastStep.onEnd();
                    if (step.onStart) step.onStart();
                    if (this._onStep) this._onStep(elapsedTime, step, deltaTime);
                }
                if (step.handler) step.handler(stepTime, deltaTime);
                if (this._onTick) this._onTick(elapsedTime, step, deltaTime);
                timeline.lastStepTime = stepTime;
                timeline.lastStep = step;
            } else this.stop();
        }
    };
    Animator.prototype.loop = function() {
        var _this = this;
        this._animationFrame = requestAnimationFrame(function() {
            _this.computeFrameAt(Date.now());
            _this.loop();
        });
    };
    Animator.prototype.start = function() {
        if (typeof this._pausedTime !== 'undefined') {
            var deltaTime = this._pausedTime - this._startTime;
            this._startTime = Date.now() - deltaTime;
        } else this._startTime = Date.now();
        this._lastTime = Date.now();
        this._pausedTime = undefined;
        this.loop();
    };
    Animator.prototype.stop = function() {
        if (this._animationFrame) cancelAnimationFrame(this._animationFrame);
        this._pausedTime = undefined;
        this._animationFrame = null;
    };
    Animator.prototype.pause = function() {
        if (this._animationFrame) cancelAnimationFrame(this._animationFrame);
        this._pausedTime = Date.now();
        this._animationFrame = null;
    };
    Animator.prototype.getDuration = function() {
        return Math.max.apply(Math, this._timelines.map(function(timeline) {
            return timeline.getDuration();
        }));
    };
    return Animator;
}();
module.exports.Animator = $db1b81f84458a82c$var$Animator;

});

parcelRegister("e8wtc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeline = void 0;
var $a4aaffe45160ff0e$var$Timeline = /** @class */ function() {
    function Timeline(steps) {
        this._steps = steps;
        this._lastStepTime = 0;
        this._lastStep = null;
    }
    Object.defineProperty(Timeline.prototype, "totalDuration", {
        get: function() {
            return this._steps.reduce(function(acc, step) {
                return acc += step.duration;
            }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timeline.prototype, "lastStep", {
        get: function() {
            return this._lastStep;
        },
        set: function(lastStep) {
            this._lastStep = lastStep;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timeline.prototype, "lastStepTime", {
        get: function() {
            return this._lastStepTime;
        },
        set: function(lastStepTime) {
            this._lastStepTime = lastStepTime;
        },
        enumerable: false,
        configurable: true
    });
    Timeline.prototype.getCurrentStep = function(time) {
        var currentTime = 0;
        for(var _i = 0, _a = this._steps; _i < _a.length; _i++){
            var step = _a[_i];
            if (time <= currentTime + step.duration) return step;
            currentTime += step.duration;
        }
        return this._steps[this._steps.length - 1];
    };
    Timeline.prototype.getDurationUntilStep = function(step) {
        var stepIndex = this._steps.indexOf(step);
        var beforeSteps = this._steps.slice(0, stepIndex);
        return beforeSteps.reduce(function(acc, it) {
            return acc += it.duration;
        }, 0);
    };
    Timeline.prototype.getDuration = function() {
        return this._steps.reduce(function(duration, step) {
            duration += step.duration;
            return duration;
        }, 0);
    };
    return Timeline;
}();
module.exports.Timeline = $a4aaffe45160ff0e$var$Timeline;

});

parcelRegister("9JUeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Step = void 0;
var $7173f146cc90c1c9$var$Step = /** @class */ function() {
    function Step() {
        this.duration = 0;
    }
    return Step;
}();
module.exports.Step = $7173f146cc90c1c9$var$Step;

});

var $37a01bc1518e38b9$exports = {};
"use strict";
var $37a01bc1518e38b9$var$__createBinding = $37a01bc1518e38b9$exports && $37a01bc1518e38b9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $37a01bc1518e38b9$var$__exportStar = $37a01bc1518e38b9$exports && $37a01bc1518e38b9$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $37a01bc1518e38b9$var$__createBinding(exports1, m, p);
};
Object.defineProperty($37a01bc1518e38b9$exports, "__esModule", {
    value: true
});

$37a01bc1518e38b9$var$__exportStar((parcelRequire("iOiPU")), $37a01bc1518e38b9$exports);

$37a01bc1518e38b9$var$__exportStar((parcelRequire("e8wtc")), $37a01bc1518e38b9$exports);

$37a01bc1518e38b9$var$__exportStar((parcelRequire("9JUeZ")), $37a01bc1518e38b9$exports);


const $df5bef30413a053b$export$1860c7b6fa9bf376 = (element, style)=>{
    for (const [key, value] of Object.entries(style))element.style[key] = value;
};
const $df5bef30413a053b$export$5bd425c26e938185 = ()=>{
    return new Promise((resolve)=>{
        document.fonts.ready.then(function() {
            resolve();
        });
    });
};


var $b4e14b6b8da86996$var$Actions = /*#__PURE__*/ function(Actions) {
    Actions["Start"] = "start";
    Actions["Stop"] = "stop";
    Actions["Reset"] = "reset";
    return Actions;
}($b4e14b6b8da86996$var$Actions || {});
const $b4e14b6b8da86996$var$MAX_RATIO = 2.2;
const $b4e14b6b8da86996$var$isMobile = ()=>{
    return window.innerWidth / window.innerHeight < $b4e14b6b8da86996$var$MAX_RATIO;
};
(async ()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const delay = urlParams.get("delay") === "true";
    await (0, $df5bef30413a053b$export$5bd425c26e938185)();
    const lines = Array.from(document.querySelectorAll(".line"));
    let translateTargets = [];
    const updateTranslateTargets = ()=>{
        translateTargets = [];
        lines.forEach((line)=>{
            const spans = line.querySelectorAll("span");
            const box = spans[0].getBoundingClientRect();
            translateTargets.push(box.width);
        });
    };
    updateTranslateTargets();
    const timeline = new (0, $37a01bc1518e38b9$exports.Timeline)([
        {
            duration: 25000,
            handler (progress) {
                lines.forEach((line, index)=>{
                    const p = index % 2 === 0 ? progress : 1 - progress;
                    (0, $df5bef30413a053b$export$1860c7b6fa9bf376)(line, {
                        transform: `translate3d(-${p * 100}%, 0, 0)`
                    });
                });
            }
        }
    ]);
    const animator = new (0, $37a01bc1518e38b9$exports.Animator)([
        timeline
    ]);
    const updateIsMobile = ()=>{
        const lines = document.querySelector(".lines");
        if ($b4e14b6b8da86996$var$isMobile()) lines?.classList.add("is-mobile");
        else lines?.classList.remove("is-mobile");
    };
    window.addEventListener("resize", ()=>{
        updateTranslateTargets();
        updateIsMobile();
    });
    updateIsMobile();
    if (delay) {
        animator.stop();
        animator.startTime = 0;
        animator.computeFrameAt(0);
        window.addEventListener("message", ({ data: data })=>{
            const { action: action } = data;
            if (action === "start") animator.start();
            else if (action === "stop") animator.stop();
            else if (action === "reset") {
                animator.startTime = 0;
                animator.computeFrameAt(0);
            }
        }, false);
    } else animator.start();
// document.addEventListener("visibilitychange", () => {
//   if (document.hidden) {
//     animator.stop();
//   } else {
//     animator.startTime = Date.now();
//     animator.start();
//   }
// });
})();


//# sourceMappingURL=path0.74ab3fd1.js.map
